const WHATSAPP_NUMBER="393318538663";
const MSG_GENERAL="Ciao, ti contatto dal sito www.massagomme.com, richiedo disponibilità per un furgone.";
const MSG_CARD=MSG_GENERAL;

const NEW_FLEET=[
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-12.jpg?v=1787659670",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-13.jpg?v=1787659682",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-14.jpg?v=1787659715",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-15.jpg?v=1787659736",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-16.jpg?v=1787659749",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-17.jpg?v=1787659765",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-18.jpg?v=1787659780",
  "https://cdn.shopify.com/s/files/1/0869/1875/8733/files/flotta-19.jpg?v=1787659800"
];
const NEW_FLEET_PRICES=[60,60,60,80,60,60,60,60];

const trackEvent=(name,params={})=>{
  if(typeof window.gtag==="function") window.gtag("event",name,params);
};

if(!document.getElementById("rental-dynamic-styles")){
  const style=document.createElement("style");
  style.id="rental-dynamic-styles";
  style.textContent=`
    .tariff-special{display:inline-flex;align-self:flex-start;background:#111;color:#fff;border-radius:999px;padding:6px 10px;font-size:10px;font-weight:950;letter-spacing:.05em}
    .calc-section{padding-top:46px;padding-bottom:26px;background:#fff}
    .kmcalc-tariffs{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:18px}
    .km-tariff{border:1px solid #cfd4d6;background:#fff;color:#111;border-radius:16px;padding:14px 16px;text-align:left;cursor:pointer;font:inherit;transition:.18s ease}
    .km-tariff span{display:block;font-size:11px;font-weight:900;text-transform:uppercase;letter-spacing:.07em;color:#6d7477;margin-bottom:3px}
    .km-tariff strong{display:block;font-size:18px;letter-spacing:-.02em}
    .km-tariff.active{background:#111;color:#fff;border-color:#111;box-shadow:0 8px 24px rgba(0,0,0,.14)}
    .km-tariff.active span{color:#c6cbcd}
    .kmcalc-fields{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:10px}
    .kmcalc-field label{display:block;font-size:13px;font-weight:900;margin-bottom:8px}
    .kmcalc-field input{width:100%;min-height:54px;border:1px solid #cfd4d6;border-radius:14px;padding:0 15px;font:inherit;font-size:17px;font-weight:800;outline:none;background:#fff;color:#111}
    .kmcalc-field input:focus{border-color:#111}
    .kmcalc-dayline{display:flex;justify-content:space-between;gap:15px;align-items:center;background:#f2f3f3;border-radius:14px;padding:12px 14px;margin:2px 0 10px;font-size:13px}
    .kmcalc-dayline b{font-size:15px}
    .kmcalc-action{width:100%;min-height:54px;border:0;border-radius:14px;padding:0 20px;background:#111;color:#fff;font-weight:950;cursor:pointer;margin-top:2px}
    .kmcalc-result{margin-top:12px}
    .kmcalc-wa{display:none;width:100%;margin-top:10px;background:#20b858;color:#fff}
    .kmcalc-wa.show{display:inline-flex}
    .kmcalc-status{font-size:12px;color:#777;margin:8px 2px 0}
    .size-guide-section{padding:34px 0 12px;background:#fff}
    .size-guide-head{display:flex;justify-content:space-between;align-items:end;gap:20px;margin-bottom:18px}
    .size-guide-head h3{font-size:clamp(28px,3vw,40px);margin:0}
    .size-guide-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}
    .size-choice{border:1px solid #e1e4e5;border-radius:20px;padding:20px;display:flex;flex-direction:column;gap:7px;min-height:210px;background:#fff}
    .size-choice em{font-style:normal;font-size:11px;font-weight:950;letter-spacing:.08em;color:#777;text-transform:uppercase}
    .size-choice strong{font-size:23px;letter-spacing:-.03em}
    .size-choice .measure{font-size:17px;font-weight:900}
    .size-choice p{color:#687074;font-size:13px;margin:0 0 8px}
    .size-choice .size-guide-cta{margin-top:auto;display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:10px 12px;border-radius:999px;background:#111;color:#fff;font-size:11px;font-weight:950}
    @media(max-width:900px){.size-guide-grid{grid-template-columns:1fr 1fr}}
    @media(max-width:620px){
      .calc-section{padding-top:30px;padding-bottom:10px}
      .kmcalc-tariffs,.kmcalc-fields,.size-guide-grid{grid-template-columns:1fr}
      .km-tariff{padding:13px 14px}
      .kmcalc-dayline{align-items:flex-start;flex-direction:column;gap:2px}
      .size-guide-section{padding-top:24px}
      .size-guide-head{display:block}
      .size-choice{min-height:0}
    }
  `;
  document.head.appendChild(style);
}

const fleetGrid=document.querySelector(".fleet");
if(fleetGrid){
  NEW_FLEET.forEach((src,i)=>{
    const price=NEW_FLEET_PRICES[i];
    const article=document.createElement("article");
    article.className="card";
    article.innerHTML=`<div class="cardimg"><img src="${src}" alt="Mezzo reale della flotta MASSAGOMME, foto ${Number(src.match(/flotta-(\d+)\.jpg/)[1])}" loading="lazy"><span>MEZZO REALE</span></div><div class="cardbody">${price===80?'<div class="tariff-special">TARIFFA 80 €</div>':''}<div class="price">${price} € <small>/ giorno</small></div><b>150 km inclusi</b><small class="fuel-exclusion">* Carburante escluso</small><p>Contattaci per conoscere dimensioni e disponibilità di questo mezzo.</p><div class="tags"><i>Senza conducente</i><i>Privati</i><i>Aziende</i></div><a class="btn wa js-wa-card" href="#">CHIEDI DISPONIBILITÀ</a></div>`;
    fleetGrid.appendChild(article);
  });

  fleetGrid.querySelectorAll(".card").forEach(card=>{
    const tags=card.querySelector(".tags");
    if(tags) tags.innerHTML="<i>Senza conducente</i><i>Privati</i><i>Aziende</i>";
  });
}

const heroText=document.querySelector(".hero-copy p");
if(heroText&&heroText.textContent.includes("Un’unica tariffa semplice")){
  heroText.textContent="Diverse dimensioni e tariffe chiare da 60 € al giorno. Questi sono realmente i mezzi che puoi noleggiare a Seregno.";
}
const centinatoCopy=document.querySelector(".centinato>div p:last-of-type");
if(centinatoCopy){
  centinatoCopy.textContent="Per chi necessita maggiore capacità di carico. Noleggio del solo mezzo, senza conducente.";
}
const realCopy=document.querySelector(".real>div p");
if(realCopy){
  realCopy.textContent="Furgoni disponibili a noleggio senza conducente per privati e aziende. Le fotografie del sito mostrano i mezzi reali della nostra flotta.";
}

const sizeCards=document.querySelectorAll("#spazio .scale > div");
if(sizeCards[0]){const s=sizeCards[0].querySelector("span");if(s)s.textContent="circa 2,50 m · lunghezza interna di carico";}
if(sizeCards[1]){const s=sizeCards[1].querySelector("span");if(s)s.textContent="circa 3,30 m · lunghezza interna di carico";}

const calcState={selectedTariff:60,selectedSize:"",lastEstimate:null};
let setTariff=()=>{};
let resetEstimate=()=>{};

const fleetSection=document.getElementById("flotta");
if(fleetSection&&!document.getElementById("km-calculator")){
  fleetSection.insertAdjacentHTML("beforebegin",`<section class="section calc-section" id="preventivo"><div class="wrap"><div class="kmcalc" id="km-calculator"><div class="kmcalc-copy"><span class="eyebrow">Preventivo indicativo</span><h3>CALCOLA COSTO E DATE DEL NOLEGGIO</h3><p>Seleziona le date di ritiro e riconsegna, scegli la tariffa del furgone e inserisci i chilometri totali previsti.</p><small>Ogni giorno di noleggio comprende 150 km. Dopo il calcolo puoi verificare subito la disponibilità delle date su WhatsApp.</small></div><div class="kmcalc-form"><div class="kmcalc-tariffs" role="group" aria-label="Scegli la tariffa del furgone"><button type="button" class="km-tariff active" data-price="60" aria-pressed="true"><span>Furgone standard</span><strong>60 € / giorno</strong></button><button type="button" class="km-tariff" data-price="80" aria-pressed="false"><span>Furgone speciale</span><strong>80 € / giorno</strong></button></div><div class="kmcalc-fields"><div class="kmcalc-field"><label for="pickup-date">Data di ritiro</label><input id="pickup-date" type="date"></div><div class="kmcalc-field"><label for="return-date">Data di riconsegna</label><input id="return-date" type="date"></div></div><div class="kmcalc-dayline"><span>Durata calcolata</span><b id="rental-days">Seleziona le date</b></div><div class="kmcalc-field"><label for="km-input">Km totali previsti</label><input id="km-input" type="number" min="1" step="1" inputmode="numeric" placeholder="Es. 300" aria-label="Km totali previsti"></div><button id="km-calc-btn" class="kmcalc-action" type="button">CALCOLA PREVENTIVO</button><div class="kmcalc-result" aria-live="polite"><span>Totale stimato</span><strong id="km-total">—</strong></div><a id="km-wa-btn" class="btn kmcalc-wa" href="#" target="_blank" rel="noopener">VERIFICA DISPONIBILITÀ DATE SU WHATSAPP</a><p class="kmcalc-status" id="km-status">Seleziona prima le date del noleggio.</p></div></div></div></section>`);
}

if(fleetSection&&!document.getElementById("size-guide")){
  fleetSection.insertAdjacentHTML("beforebegin",`<section class="size-guide-section" id="size-guide"><div class="wrap"><div class="size-guide-head"><div><span class="eyebrow">Scegli la misura</span><h3>QUALE FURGONE TI SERVE?</h3></div><p class="lede">Parti dalla lunghezza interna indicativa. Le misure esatte del singolo mezzo vengono confermate da MASSAGOMME.</p></div><div class="size-guide-grid"><article class="size-choice"><em>01 · Standard</em><strong>Compatto</strong><span class="measure">circa 2,50 m</span><p>Per chi cerca il mezzo più compatto della flotta.</p><a class="size-guide-cta" href="#preventivo" data-size="Compatto ~2,50 m" data-tariff="60">CALCOLA E VERIFICA DATE</a></article><article class="size-choice"><em>02 · Standard</em><strong>Medio</strong><span class="measure">circa 3,30 m</span><p>Una soluzione intermedia con maggiore lunghezza di carico.</p><a class="size-guide-cta" href="#preventivo" data-size="Medio ~3,30 m" data-tariff="60">CALCOLA E VERIFICA DATE</a></article><article class="size-choice"><em>03 · Standard</em><strong>Grande</strong><span class="measure">fino a circa 3,70 m</span><p>Per esigenze di carico maggiori, sempre senza conducente.</p><a class="size-guide-cta" href="#preventivo" data-size="Grande fino a ~3,70 m" data-tariff="60">CALCOLA E VERIFICA DATE</a></article><article class="size-choice"><em>04 · Tariffa 80 €</em><strong>Centinato</strong><span class="measure">circa 4,10 m</span><p>La soluzione con maggiore capacità indicativa.</p><a class="size-guide-cta" href="#preventivo" data-size="Centinato ~4,10 m" data-tariff="80">CALCOLA E VERIFICA DATE</a></article></div></div></section>`);
}

const pickupInput=document.getElementById("pickup-date");
const returnInput=document.getElementById("return-date");
const kmInput=document.getElementById("km-input");
const kmButton=document.getElementById("km-calc-btn");
const kmTotal=document.getElementById("km-total");
const kmWaButton=document.getElementById("km-wa-btn");
const rentalDays=document.getElementById("rental-days");
const kmStatus=document.getElementById("km-status");
const tariffButtons=[...document.querySelectorAll(".km-tariff")];

const parseDateUTC=value=>{
  if(!value) return null;
  const [y,m,d]=value.split("-").map(Number);
  if(!y||!m||!d) return null;
  return Date.UTC(y,m-1,d);
};
const formatDateIT=value=>{
  if(!value) return "";
  const [y,m,d]=value.split("-");
  return `${d}/${m}/${y}`;
};
const getDays=()=>{
  const start=parseDateUTC(pickupInput?.value);
  const end=parseDateUTC(returnInput?.value);
  if(start===null||end===null||end<start) return null;
  return Math.floor((end-start)/86400000)+1;
};
const refreshDays=()=>{
  const days=getDays();
  if(days===null){
    if(rentalDays) rentalDays.textContent="Seleziona date valide";
    return null;
  }
  if(rentalDays) rentalDays.textContent=`${days} ${days===1?"giorno":"giorni"} · ${days*150} km inclusi`;
  return days;
};
resetEstimate=()=>{
  calcState.lastEstimate=null;
  if(kmTotal) kmTotal.textContent="—";
  if(kmWaButton){kmWaButton.classList.remove("show");kmWaButton.href="#";}
  if(kmStatus) kmStatus.textContent="Compila i dati e premi “Calcola preventivo”.";
};
setTariff=price=>{
  calcState.selectedTariff=Number(price)===80?80:60;
  tariffButtons.forEach(button=>{
    const active=Number(button.dataset.price)===calcState.selectedTariff;
    button.classList.toggle("active",active);
    button.setAttribute("aria-pressed",active?"true":"false");
  });
  resetEstimate();
};

if(pickupInput&&returnInput&&kmInput&&kmButton&&kmTotal&&kmWaButton){
  const today=new Date();
  const todayLocal=`${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}-${String(today.getDate()).padStart(2,"0")}`;
  pickupInput.min=todayLocal;
  returnInput.min=todayLocal;

  pickupInput.addEventListener("change",()=>{
    returnInput.min=pickupInput.value||todayLocal;
    if(returnInput.value&&pickupInput.value&&returnInput.value<pickupInput.value) returnInput.value="";
    refreshDays();
    resetEstimate();
  });
  returnInput.addEventListener("change",()=>{refreshDays();resetEstimate();});
  kmInput.addEventListener("input",resetEstimate);

  tariffButtons.forEach(button=>button.addEventListener("click",()=>setTariff(button.dataset.price)));

  const calculateRental=()=>{
    const days=refreshDays();
    const km=Math.ceil(Number(kmInput.value));
    if(days===null){
      kmTotal.textContent="—";
      kmStatus.textContent="Controlla le date: la riconsegna non può essere precedente al ritiro.";
      kmWaButton.classList.remove("show");
      return;
    }
    if(!Number.isFinite(km)||km<1){
      kmTotal.textContent="—";
      kmStatus.textContent="Inserisci i chilometri totali previsti.";
      kmWaButton.classList.remove("show");
      return;
    }

    const dayCost=days*calcState.selectedTariff;
    const distanceCost=(km/150)*calcState.selectedTariff;
    const raw=Math.max(dayCost,distanceCost);
    const total=Math.ceil(raw/10)*10;
    const sizeLine=calcState.selectedSize?`\nDimensione richiesta: ${calcState.selectedSize}`:"";
    const message=`Ciao, ti contatto dal sito www.massagomme.com. Vorrei verificare la disponibilità di un furgone senza conducente per queste date:\n\nRitiro: ${formatDateIT(pickupInput.value)}\nRiconsegna: ${formatDateIT(returnInput.value)}\nGiorni: ${days}${sizeLine}\nTariffa selezionata: ${calcState.selectedTariff} € / giorno\nKm totali previsti: ${km}\nPreventivo indicativo: ${total} €\n\nPuoi confermarmi la disponibilità per queste date?`;

    calcState.lastEstimate={
      days,km,total,tariff:calcState.selectedTariff,
      pickup:pickupInput.value,returnDate:returnInput.value,size:calcState.selectedSize
    };
    kmTotal.textContent=`${total} €`;
    kmStatus.textContent="Preventivo indicativo pronto. Verifica ora la disponibilità delle date.";
    kmWaButton.href=`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    kmWaButton.classList.add("show");

    trackEvent("preventivo_calcolato",{
      giorni:days,
      km:km,
      tariffa:calcState.selectedTariff,
      totale:total,
      data_ritiro:pickupInput.value,
      data_riconsegna:returnInput.value,
      dimensione:calcState.selectedSize||"non_selezionata"
    });
  };

  kmButton.addEventListener("click",calculateRental);
  [pickupInput,returnInput,kmInput].forEach(input=>input.addEventListener("keydown",e=>{if(e.key==="Enter")calculateRental();}));

  kmWaButton.addEventListener("click",()=>{
    if(!calcState.lastEstimate) return;
    trackEvent("whatsapp_dopo_preventivo",{
      giorni:calcState.lastEstimate.days,
      km:calcState.lastEstimate.km,
      tariffa:calcState.lastEstimate.tariff,
      totale:calcState.lastEstimate.total,
      data_ritiro:calcState.lastEstimate.pickup,
      data_riconsegna:calcState.lastEstimate.returnDate,
      dimensione:calcState.lastEstimate.size||"non_selezionata"
    });
  });
}

document.querySelectorAll(".size-guide-cta").forEach(link=>{
  link.addEventListener("click",()=>{
    calcState.selectedSize=link.dataset.size||"";
    setTariff(Number(link.dataset.tariff)||60);
    if(kmStatus) kmStatus.textContent=`Hai selezionato: ${calcState.selectedSize}. Ora scegli le date e i km.`;
    trackEvent("selezione_dimensione",{dimensione:calcState.selectedSize,tariffa:calcState.selectedTariff});
  });
});

const gallery=document.querySelector(".gallery");
if(gallery){
  NEW_FLEET.forEach((src,i)=>{
    const button=document.createElement("button");
    button.className="gallery-item";
    button.type="button";
    button.innerHTML=`<img src="${src}" alt="Flotta reale MASSAGOMME, foto ${Number(src.match(/flotta-(\d+)\.jpg/)[1])}" loading="lazy"><span></span>`;
    gallery.appendChild(button);
  });
  const items=[...gallery.querySelectorAll(".gallery-item")];
  items.forEach((item,i)=>{const span=item.querySelector("span");if(span)span.textContent=`${i+1} / ${items.length}`;});
  document.querySelectorAll(".eyebrow").forEach(el=>{if(el.textContent.trim()==="10 fotografie originali")el.textContent=`${items.length} fotografie originali`;});
}

document.querySelectorAll(".js-wa-general").forEach(a=>{
  a.href=`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MSG_GENERAL)}`;
  a.target="_blank";
  a.rel="noopener";
  a.addEventListener("click",()=>trackEvent("whatsapp_click",{tipo:"generale"}));
});
document.querySelectorAll(".js-wa-card").forEach(a=>{
  a.href=`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MSG_CARD)}`;
  a.target="_blank";
  a.rel="noopener";
  a.addEventListener("click",()=>trackEvent("whatsapp_click",{tipo:"scheda_furgone"}));
});

const lb=document.getElementById("lightbox");
if(lb){
  const lbImg=lb.querySelector("img");
  document.querySelectorAll(".gallery-item").forEach(item=>item.addEventListener("click",()=>{const img=item.querySelector("img");lbImg.src=img.currentSrc||img.src;lb.classList.add("open");lb.setAttribute("aria-hidden","false")}));
  const closeLightbox=()=>{lb.classList.remove("open");lb.setAttribute("aria-hidden","true");lbImg.src=""};
  lb.querySelector("button")?.addEventListener("click",closeLightbox);
  lb.addEventListener("click",e=>{if(e.target===lb)closeLightbox()});
  document.addEventListener("keydown",e=>{if(e.key==="Escape")closeLightbox()});
}
